"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAngularCoordinateSystem = void 0;
/**
 * Create an angular coordinate system centered around a zero point and at an
 * angle, for translating points.  Useful for drawing objects into to match
 * an object that rotated or for drawing such objects as rotated rectangles.
 *
 * @param zeroPoint The center of the coordinate system
 * @param angleInRadians The angle at which it is rotated.
 */
const createAngularCoordinateSystem = (zeroPoint, angleInRadians) => {
    const cosAngle = Math.cos(angleInRadians);
    const sinAngle = Math.sin(angleInRadians);
    const pointAtAsXy = (offset) => ({
        x: zeroPoint.x + offset.x * cosAngle - offset.y * sinAngle,
        y: zeroPoint.y + offset.x * sinAngle + offset.y * cosAngle
    });
    const pointAtAsTuple = (offset) => [
        zeroPoint.x + offset.x * cosAngle - offset.y * sinAngle,
        zeroPoint.y + offset.x * sinAngle + offset.y * cosAngle
    ];
    return { pointAtAsXy, pointAtAsTuple };
};
exports.createAngularCoordinateSystem = createAngularCoordinateSystem;
//# sourceMappingURL=create-angular-coordinate-system.js.map